<style lang="stylus">
    html.dark
        .MsgBox-mask  .msgbox
            border none
    .MsgBox-mask
        modal-mask()
        background-color unset
        .dialog-btnbox-normal{
          padding-right: 24px

        }
        .msgbox
            position absolute
            left 50%
            top 50%
            padding-bottom 20px
            transform translate(-50%, -50%)
            background-color var(--bg-color-tertiary)
            z-index 30
            border-radius: $box-radius
            border: 1px solid $box-bordercolor;
            box-shadow $box-shadow
            width 378px
            overflow auto
            user-select none
            .msgbox-title
                font-weight: 600
                z-index 30
                position relative
                height 42px
                width 100%
                padding 0 15px
                background-color var(--bg-color-tertiary)
                color $modal-title-textcolor
                font-size $modal-title-textsize
                border-top-left-radius 5px
                border-top-right-radius 5px
                cursor move
                user-select none
                .item-icon
                    position absolute
                    width 25px
                    height 21px
                    left 20px
                    top 10px
                .title-text
                    position absolute
                    left: 24px;
                    font-weight: 700;
                    font-size 14px
                    line-height 42px
                .title-close
                    position absolute
                    top 9px
                    right 15px
                    width 25px
                    height 25px
                    cursor pointer
                    color: var(--svg-color-gray-42)
                    >svg
                        position absolute
                        top 50%
                        left 50%
                        transform translate(-50%, -50%)
                        width 17px
                        height 17px
            .MsgBox-warn
                margin 20px auto 0 auto
                width 58px
                height 49px
                .item-icon
                    width 58px
                    height 49px
            .inline-block
                display inline-block
                div
                    height 28px;
                    line-height 28px
                .dialog-btn-ok.warning
                    background: rgba(255, 64, 64, 1);

    .MsgBox-container
        padding 15px 20px
        .MsgBox-line
            display flex
            align-items center
            .item-icon {
                width: 24px;
                height: 24px;
                margin-right: 8px;
            }
            >div
                line-height 24px
                font-size 13px
                color var(--text-color-primary)
</style>

<template>
    <div class="MsgBox-mask">
        <div ref="msgbox" class="msgbox" :class="message.msgClass">
            <div v-if="message.type == 0 || message.type == 1" ref="msgboxTitle" class="msgbox-title">
                <p class="title-text">{{ message.title || $t(defaultTitle) }}</p>
                <div class="title-close" @click="cancel()" @mousedown.stop>
                    <iconSymbol name="Del" />
                </div>
            </div>

            <div v-if="message.type == 2" class="MsgBox-warn">
                <iconSymbol class="item-icon" :name="setImgType()" />
            </div>

            <div class="MsgBox-container">
                <div class="MsgBox-line">
                    <div>
                        <iconSymbol v-if="imgType == 3" class="item-icon" :name="setImgType()" />
                        <iconSymbol v-else class="item-icon" name="small-warn" />
                    </div>
                    <div>
                        <p v-html="message.content"></p>
                        <p v-if="message.extraCon">{{ message.extraCon }}</p>
                    </div>
                </div>
            </div>

            <div v-if="message.type == 0" class="dialog-btnbox-normal">
                <Checkbox class="dialog-btn-checkbox" v-if="message.avoid" :value="isRemind" @on-change="setNotRemind">
                    {{ $t("notRemind") }}
                </Checkbox>
                <span class="inline-block">
                    <div class="dialog-btn-ok" :class="message.confirmType" @click="confirm()">{{ confirmText }}</div>
                    <div class="" @click="cancel()">{{ cancelText }}</div>
                </span>
            </div>

            <div v-if="message.type == 1 || message.type == 2" class="dialog-btnbox-return">
                <div @click="cancel()" @mouseenter="blockClose()" @mouseout="cancelBlock()">
                    {{ `${$t("close")}(${$t("closePre")} ${closeTime} ${$t("closeSuf")})` }}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class MsgBox extends Vue {
        defaultTitle: string = "remind";
        attr: object = { left: 0, top: 0 };
        closeTime: number = 3;
        imgType: number = 0; // 弹窗图片类型
        closeTimer: number = 0; // 关闭计时器
        blocker: boolean = false; // 阻塞关闭事件
        isRemind: boolean = false; // 记住不在提示
        // dragbox
        setImgType() {
            if (this.imgType == 0) {
                // 警告图标
                return "big-warn";
            } else if (this.imgType == 1) {
                // 成功图标
                return "big-success";
            } else if (this.imgType == 2) {
                // 失败图标
                return "big-fail";
            } else if (this.imgType == 3) {
                // 成功
                return "publishSuccess";
            } else {
                return "big-warn";
            }
        }
        getStyle(dom, attr) {
            return dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom)[attr];
        }
        setAttr(dom) {
            this.attr["left"] = parseInt(this.getStyle(dom, "left")) || 0;
            this.attr["top"] = parseInt(this.getStyle(dom, "top")) || 0;
        }
        returnAttr(dom, x, y) {
            dom.style.left = x + "px";
            dom.style.top = y + "px";
        }
        drag(a, t) {
            a.onmousedown = (e) => {
                this.setAttr(t);
                document.onmousemove = (b) => {
                    var x = b.clientX - e.clientX;
                    var y = b.clientY - e.clientY;
                    this.returnAttr(t, x + this.attr["left"], y + this.attr["top"]);
                    if (b.preventDefault) {
                        b.preventDefault();
                    }
                };
                document.onmouseup = () => {
                    document.onmouseup = null;
                    document.onmousemove = null;
                };
            };
        }
        // 自动关闭
        autoClose() {
            this.closeTimer = setInterval(() => {
                if (this.blocker) return;
                if (this.closeTime <= 1) {
                    this.closeTime = 1;
                    this.closeModal();
                } else {
                    --this.closeTime;
                }
            }, 1000);
        }
        blockClose() {
            this.blocker = true;
        }
        cancelBlock() {
            this.blocker = false;
        }

        // 操作函数
        sendInfo(data) {
            if (this.message.sponsor) {
                console.log("msgbox: send msg to", this.message.sponsor);
                let ts: any = this;
                let eventName = "msgOperation";
                if (this.message.uniqueListenr) {
                    eventName = `msgOperation-${this.message.sponsor}`;
                }
                ts.$bus.$emit(eventName, {
                    sponsor: this.message.sponsor,
                    temp: this.message.temp,
                    data: data,
                });
            }
        }
        confirm() {
            this.sendInfo(true);
            if (this.message.avoid && this.isRemind) {
                let store = localStorage;
                let list = JSON.parse(store.getItem("msgAvoidList")) || [];
                list.push(this.message.avoidTitle);
                store.setItem("msgAvoidList", JSON.stringify(list));
            }
            this.closeModal();
        }
        cancel() {
            this.sendInfo(false);
            this.closeModal();
        }
        closeModal() {
            if (this.message.type == 1 || this.message.type == 2) clearInterval(this.closeTimer);
            this.$store.commit("setDialogState", {
                type: "showMsg",
                data: false,
            });
        }
        setNotRemind(v) {
            this.isRemind = v;
        }

        get message() {
            return this.$store.state.dialog.message;
        }
        get confirmText() {
            let str = this.$t("confirm") as string;
            if (this.message.btnType == 1) {
                str = this.$t("yes") as string;
            }
            if (this.message.confirmText !== undefined) {
                str = this.message.confirmText;
            }
            return str;
        }
        get cancelText() {
            let str = this.$t("cancel") as string;
            if (this.message.btnType == 1) {
                str = this.$t("no") as string;
            }
            return str;
        }

        mounted() {
            window["_view"].cancelMouseEvent();
            this.closeTime = this.message.time;
            this.imgType = this.message.imgType;
            if (this.message.type == 0) {
                this.drag(this.$refs.msgboxTitle, this.$refs.msgbox); // 开启标题拖拽功能
            } else if (this.message.type == 1) {
                this.autoClose();
                this.drag(this.$refs.msgboxTitle, this.$refs.msgbox); // 开启标题拖拽功能
            } else if (this.message.type == 2) {
                this.autoClose();
                this.drag(this.$refs.msgbox, this.$refs.msgbox); // 开启盒子拖拽功能
            }
            if (!this.message.title) {
                this.defaultTitle = "remind";
            }
        }
        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "warn": "警告",
    "fail": "错误",
    "success": "成功",
    "remind": "提示",
    "confirm": "确定",
    "cancel": "取消",
    "close": "关闭",
    "closePre": "于",
    "closeSuf": "秒后关闭",
    "notRemind": "不再提示",
    "yes": "是",
    "no": "否"
  },
  "en": {
    "warn": "Warning",
    "fail": "Failure",
    "success": "Success",
    "remind": "Reminder",
    "confirm": "OK",
    "cancel": "Cancel",
    "close": "Close",
    "closePre": "Close after",
    "closeSuf": "seconds",
    "notRemind": "Not Remind",
    "yes": "Yes",
    "no": "No"
  },
  "fr": {
    "warn": "Avertissement",
    "fail": "Erreur",
    "success": "Succès",
    "remind": "Rappeler",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "close": "Fermer",
    "closePre": "Fermer après",
    "closeSuf": "secondes",
    "notRemind": "Ne plus rappeler",
    "yes": "Oui",
    "no": "Non"
  },
  "de": {
    "warn": "Warnung",
    "fail": "Fehler",
    "success": "Erfolg",
    "remind": "Hinweis ",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "close": "Abschließen",
    "closePre": "Schliessen nach",
    "closeSuf": "Sekunden",
    "notRemind": "Kein Hinweis",
    "yes": "Ja",
    "no": "Nein"
  },
  "jp": {
    "warn": "警告",
    "fail": "エラー",
    "success": "成功",
    "remind": "ご注意",
    "confirm": "OK",
    "cancel": "キャンセル",
    "close": "閉じる",
    "closePre": "このウィンドウは",
    "closeSuf": "秒後に閉じられます",
    "notRemind": "再度表示しない",
    "yes": "はい",
    "no": "いいえ"
  },
  "es": {
    "warn": "Advertencia",
    "fail": "Fallo",
    "success": "Éxito",
    "remind": "Recordatorio",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "closePre": "Cerrar despues de",
    "closeSuf": "segundos",
    "notRemind": "No recordar",
    "yes": "Yes",
    "no": "No"
  },
  "pt": {
    "warn": "Aviso",
    "fail": "Falha",
    "success": "Sucesso",
    "remind": "Alerta",
    "confirm": "OK",
    "cancel": "Cancelar",
    "close": "Fechar",
    "closePre": "Fechar após",
    "closeSuf": "segundos",
    "notRemind": "Não se lembrar",
    "yes": "Sim",
    "no": "Não"
  },
  "it": {
    "warn": "Avviso",
    "fail": "Fallimento",
    "success": "Successo",
    "remind": "Promemoria",
    "confirm": "OK",
    "cancel": "Annulla",
    "close": "Chiudi",
    "closePre": "Chiudi dopo",
    "closeSuf": "secondi",
    "notRemind": "Non richiamare",
    "yes": "Sì",
    "no": "No"
  },
  "tw": {
    "warn": "警告",
    "fail": "錯誤",
    "success": "成功",
    "remind": "提示",
    "confirm": "確定",
    "cancel": "取消",
    "close": "關閉",
    "closePre": "於",
    "closeSuf": "秒後關閉",
    "notRemind": "不再提示",
    "yes": "是",
    "no": "否"
  },
  "kr": {
    "warn": "경고",
    "fail": "실패",
    "success": "성공",
    "remind": "제시",
    "confirm": "확인",
    "cancel": "취소",
    "close": "닫기",
    "closePre": "다음 시간 이후 닫기",
    "closeSuf": "초 후에 닫기",
    "notRemind": "더 이상 제시하지 않기",
    "yes": "네",
    "no": "아니오"
  }
}
</i18n>
